import React, { useState } from "react";
import forgetimage from "../../images/signin-g.svg";
import { Link } from "react-router-dom";
import ScrollToTop from "../ScrollToTop";
import api from "../../utils/api";

const MyAccountForgetPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!email) {
      setError("Email is required");
      return;
    }

    try {
      setLoading(true);

      const res = await api.post(
        "/api/auth/forgot-password", // ✅ FIXED ROUTE
        { email }
      );

      setSuccess(
        res.data?.message ||
          "If the email exists, a reset link has been sent"
      );
    } catch (err) {
      console.error("FORGOT PASSWORD ERROR:", err);
      setError(
        err.response?.data?.message ||
          "Unable to send reset link"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <ScrollToTop />

      <section className="my-lg-14 my-8">
        <div className="container">
          <div className="row justify-content-center align-items-center">

            {/* IMAGE */}
            <div className="col-12 col-md-6 col-lg-4 order-lg-1 order-2 text-center">
              <img
                src={forgetimage}
                alt="forgot password"
                className="img-fluid"
                style={{ maxWidth: "360px" }}
              />
            </div>

            {/* FORM */}
            <div className="col-12 col-md-6 offset-lg-1 col-lg-4 order-lg-2 order-1">
              <div className="mb-4">
                <h1 className="h2 fw-bold mb-1">
                  Forgot Password?
                </h1>
                <p className="text-muted">
                  Enter your registered email address and we’ll send you a
                  password reset link.
                </p>
              </div>

              {error && (
                <div className="alert alert-danger">
                  {error}
                </div>
              )}
              {success && (
                <div className="alert alert-success">
                  {success}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter your email address"
                    value={email}
                    onChange={(e) =>
                      setEmail(e.target.value)
                    }
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={loading}
                >
                  {loading
                    ? "Sending link..."
                    : "Send Reset Link"}
                </button>
              </form>

              <div className="text-center mt-3">
                <Link to="/MyAccountSignIn">
                  ← Back to Sign In
                </Link>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default MyAccountForgetPassword;